import React from 'react';
import type { CodeEmbedConfig } from './types';
import { getCodeEmbedUrl } from './embedUtils';

interface CodeEmbedProps {
  config: CodeEmbedConfig;
  lazyLoad?: boolean;
}

export const CodeEmbed: React.FC<CodeEmbedProps> = ({ config, lazyLoad }) => {
  const codeUrl = getCodeEmbedUrl(config);
  if (!codeUrl) return null;

  return (
    <iframe
      src={codeUrl}
      width={config.width || '100%'}
      height={config.height || '500'}
      style={{ border: '1px solid #ddd', borderRadius: '4px' }}
      allowFullScreen
      loading={lazyLoad ? 'lazy' : undefined}
      title="Embedded code"
    />
  );
};
